module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-1-1500x630.424981ef.jpg";